import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { APP_ENV } from '../app-environment';
import { FirebaseAuthService } from './firebase-auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const env = inject(APP_ENV);
  const auth = inject(FirebaseAuthService);
  const token = auth.idToken();

  const devUser = typeof localStorage !== 'undefined' ? localStorage.getItem('X-Development-User') : null;

  if (devUser) {
    req = req.clone({
      setHeaders: {
        'X-Development-User': devUser
      }
    });
  }

  if (!token || !req.url.startsWith(env.apiBaseUrl)) {
    return next(req);
  }

  const cloned = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`
    }
  });

  return next(cloned);
};
